import React, { useState, Fragment, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
  Box,
  AppBar,
  Tabs,
  Tab,
  Typography,
  Link,
  InputBase,
  ClickAwayListener,
  Badge,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  FormGroup,
  FormControlLabel,
  Switch,
  CircularProgress
} from '@material-ui/core';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
import PanelTemplate from '../../common/PanelTemplate';
import SystemsTable from '../SystemsTable';
import SearchIcon from '../Icons/search';
import FilterIcon from '../Icons/filterIcon';
import settings from '../../../utils/settings';
import { isEmpty, get } from '../../../utils/lodash';
import analytics from '../../../utils/analytics';
import I18n from '../../../config/locales';
import LightTooltip from '../../common/LightTooltip';
import SystemHeaderFooter from '../SystemHeaderFooter';
import { getPlatformBasedUrl } from '../../../config/platformBasedUrls/url';
import { getToken } from '../../../utils/helper';
import feature from '../../../utils/feature';
import {
  getAllActivationList,
  getAllAlertList
} from '../../../../src/containers/Dashboard/actions';

const AntTabs = withStyles(theme => ({
  root: {
    height: theme.spacing(6)
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
    minHeight: theme.spacing(1),
    borderRadius: theme.spacing(1)
  },
  scroller: {
    position: 'relative'
  },
  flexContainer: {
    borderBottom: '1px solid #B4B4B4',
    display: 'flex',
    height: theme.spacing(5.5)
  }
}))(Tabs);

const AntTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    color: '#BFC2C4',
    fontSize: 15,
    opacity: 1,
    margin: theme.spacing(0, 2),
    '&:hover': {
      color: '#335977',
      opacity: 1
    },
    '&$selected': {
      color: '#335977',
      fontWeight: theme.typography.fontWeightMedium
    }
  },
  selected: {}
}))(props => <Tab disableRipple {...props} />);

const useStyles = makeStyles(theme => ({
  root: {
    width: '60%',
    minWidth: '60%',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
      width: props => (props.windowWidth ? props.windowWidth - 74 : '100%')
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 'auto',
      width: props => (props.windowWidth ? props.windowWidth - 58 : '100%')
    }
  },
  tabsWrapper: {
    minHeight: theme.spacing(59.7),
    maxHeight: theme.spacing(59.7)
  },
  tabHeader: {
    backgroundColor: theme.palette.secondary.main,
    boxShadow: 'none'
  },
  tabPanel: {
    padding: theme.spacing(0, 2)
  },
  systemFooter: {
    display: 'flex',
    justifyContent: 'flex-start'
  },
  systemButton: {
    padding: theme.spacing(2),
    color: theme.palette.tertiary.main,
    fontSize: 13
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0
  },
  search: {
    position: 'relative',
    height: theme.spacing(5),
    display: 'flex',
    alignItems: 'center',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    border: '1px solid #70707080',
    borderRadius: theme.spacing(0.75),
    padding: theme.spacing(0, 1.5),
    width: theme.spacing(41)
  },
  inputField: {
    fontSize: 13,
    letterSpacing: 0,
    width: 'calc(100% - 32px)',
    '& input': {
      '&::placeholder': {
        textOverflow: 'ellipsis !important'
      }
    }
  },
  systemLabel: {
    display: 'flex'
  },
  systemCount: {
    color: '#FFFFFF',
    height: theme.spacing(1.5),
    // width: theme.spacing(1.5),
    display: 'flex',
    fontSize: 9,
    alignItems: 'center',
    fontWeight: 'bold',
    borderRadius: theme.spacing(1),
    letterSpacing: 0,
    lineHeight: 0,
    justifyContent: 'center',
    background: '#BE0000 0% 0% no-repeat padding-box',
    padding: theme.spacing(0, 0.5)
  },
  searchListWrapper: {
    position: 'absolute',
    marginTop: theme.spacing(5),
    zIndex: 3,
    backgroundColor: 'white',
    width: theme.spacing(38),
    padding: theme.spacing(1, 1.5),
    boxShadow: '0px 0px 8px #00000029',
    maxHeight: theme.spacing(39),
    overflow: 'scroll',
    display: 'flex',
    flexDirection: 'column'
  },
  searchList: {
    padding: theme.spacing(1, 0),
    color: theme.palette.tertiary.main,
    fontSize: 15
  },
  noResult: {
    padding: theme.spacing(1, 0),
    fontSize: 15,
    opacity: 0.7
  },
  searchWrapper: {
    margin: theme.spacing(1.5, 2, 0, 2),
    display: 'flex'
  },
  filterIcon: {
    padding: theme.spacing(0),
    marginLeft: theme.spacing(2.5)
  },
  filterText: {
    fontSize: 14,
    fontWeight: 'bold'
  },
  formControl: {
    width: theme.spacing(35),
    margin: theme.spacing(2, 1)
  },
  filterWrapper: {
    position: 'absolute',
    top: 0,
    left: 'calc(100% - 12px)',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '0px 0px 6px #00000029',
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(0, 1.5),
    fontSize: 11,
    letterSpacing: 0.1,
    display: 'flex',
    whiteSpace: 'nowrap'
  },
  filterIconWrapper: {
    display: 'flex',
    position: 'relative'
  },
  closeIcon: {
    fontSize: theme.spacing(2.5),
    position: 'absolute',
    right: -8,
    top: -8,
    fill: '#AAA9A9',
    stroke: '#fff',
    background: '#fff',
    borderRadius: '50%',
    cursor: 'pointer'
  },
  switchLeadStatus: {
    marginLeft: 'auto'
  },
  loader: {
    marginLeft: '45%',
    marginTop: '15%'
  },
  switchLeadFormGroup: {
    flexDirection: 'row'
  },
  allLeads: {
    color: theme.palette.primary.lightGray,
    marginTop: theme.spacing(1.3),
    marginRight: theme.spacing(2)
  },
  loaderSystemsTable: {
    marginLeft: '45%',
    marginTop: '5%',
    marginBottom: '5%'
  }
}));

const Systems = props => {
  const gaAnalytics = new analytics();
  const classes = useStyles(props);
  const [value, setValue] = useState(0);
  const [field, setField] = useState('all');
  const [showFilterTooltip, setShowFilterTooltip] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [selectedFilter, setSelectedFilter] = useState({ alert: { name: 'all' }, activation: { name: 'all' } });
  const [filterOptions, setFilterOptions] = useState([]);
  const [showActiveLeads, setShowActiveLeads] = useState(true);
  const [currentFetchingLeads, setCurrentlyFetchingLeads] = useState(false);
  const {
    dashboardList,
    activationList,
    alertList,
    leadList,
    searchList,
    getSearchResult,
    resetSearchData,
    companyId,
    leadOptIn = false,
    leadsLoading,
    systemSavedSearch,
    getFilteredList,
    getLeads = () => { },
    fromITK,
    systemLoadingProps,
    accountData,
    dashboardLoading
  } = props;
  const { systemLoading, activationLoading, alertLoading } = systemLoadingProps;
  const alertListTotalCount = dashboardList.alert_count === null ? 0 : dashboardList.alert_count;
  const activationListTotalCount = dashboardList.activation_count === null ? 0 : dashboardList.activation_count;
  const leadListTotalCount = leadList.totalLeads === null ? 0 : leadList.totalLeads;
  const leadNewTotalCount = leadList.totalNewLeads === null ? 0 : leadList.totalNewLeads;
  const systemSearch = get(systemSavedSearch, 'system_groups', []) || [];
  const siteSavedSearch = get(systemSavedSearch, 'site_saved_searches', []) || [];
  const activationSavedSearch = get(systemSavedSearch, 'activation_saved_searches', []) || [];
  const savedSearch = siteSavedSearch.map(search => {
    search.isSavedSearch = true;
    return search;
  });
  const manager_token = getToken()

  const isSelfInstaller = get(accountData, 'self_installer', false)
  const enableNewActivationOnly = feature.isFeatureEnabled('ENABLE_NEW_ACTIVATION_ONLY')
  const isActivationenalbed = feature.isFeatureEnabled('ACTIVATION_WEB_FEATURE') || isSelfInstaller

  const activationSearch = activationSavedSearch.map(search => {
    search.isSavedSearch = true;
    return search;
  });
  const showAddNew = value !== 1;
  useEffect(
    () => {
      let filterOptions = [];
      if (field === 'alert') {
        !isEmpty(savedSearch) && filterOptions.push(...savedSearch);
        !isEmpty(systemSearch) && filterOptions.push(...systemSearch);
      } else if (field === 'activation') {
        !isEmpty(activationSearch) && filterOptions.push(...activationSearch);
      }
      setFilterOptions([...filterOptions]);
    },
    [field]
  );

  const leadsCount1 = leadsLoading => {
    return (
      <span>
        {leadsLoading ? (
          I18n.t('dashboard.leads')
        ) : leadNewTotalCount > 0 ? (
          <span>
            <Badge badgeContent={leadNewTotalCount} color="error">
              <Typography style={{ paddingRight: '16px' }}>{I18n.t('dashboard.leads')}</Typography>
            </Badge>
          </span>
        ) : (
          `${I18n.t('dashboard.leads')} (${leadListTotalCount})`
        )}
      </span>
    );
  };
  const leadsCount = leadsLoading ? I18n.t('dashboard.leads') : `${I18n.t('dashboard.leads')} (${leadListTotalCount})`;
  const trackEvent = systemName => {
    const dataLayer = {
      systemTabValue: systemName
    };
    gaAnalytics.triggerEvent({ event: 'triggerSystemTab' }, dataLayer);
  };

  const handleChange = (event, newValue) => {

    setValue(newValue);
    let systemName = 'All';
    switch (newValue) {
      case 0:
        setField('all');

        break;
      case 1:
        setField('alert');
        systemName = 'Alerts';
        props.getAllAlertList({});
        break;
      case 2:
        setField('activation');
        systemName = 'Activations';
        props.getAllActivationList({});
        break;
      case 3:
        setField('lead');
        systemName = 'Leads';
        break;
      default:
        setField('all');
        break;
    }
    setSearchValue('');
    resetSearchData();
    setShowSearchResult(false);
    trackEvent(systemName);
  };

  const handleSearch = event => {
    const newValue = event.target.value;
    setSearchValue(newValue);
    getSearchResult(newValue, field);
  };

  const TabPanel = props => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box className={classes.tabPanel}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
  };

  // const getTabLabel = (labelText, totalCount = 0) => {
  //   if (totalCount > 0) {
  //     return (
  //       <Box className={classes.systemLabel}>
  //         <Typography>{labelText}</Typography>
  //         <Typography className={classes.systemCount}>{totalCount}</Typography>
  //       </Box>
  //     );
  //   }
  //   return labelText;
  // };
  // const getSummaryTotal = tCount => {
  //   return (
  //     <Typography style={{ textAlign: 'center', color: '#999999', paddingLeft: '40px' }}>
  //       <span style={{ fontSize: '12px' }}>{I18n.t('dashboard.total')}</span>
  //       <br />
  //       <span style={{ fontWeight: 'bold', color: '#F37320' }}>{tCount || 0}</span>
  //     </Typography>
  //   );
  // };
  // const getSummaryLeads = tCount => {
  //   return (
  //     <Typography style={{ textAlign: 'center', opacity: 1, color: '#999999' }}>
  //       <span style={{ fontSize: '12px' }}>{I18n.t('dashboard.leads')}</span>
  //       <br />
  //       <span style={{ fontWeight: 'bold', color: '#F37320' }}>{tCount || 0}</span>
  //     </Typography>
  //   );
  // };
  // const getSummaryActivation = tCount => {
  //   return (
  //     <Typography style={{ textAlign: 'center', opacity: 1, color: '#999999' }}>
  //       <span style={{ fontSize: '12px' }}>{I18n.t('dashboard.activations')}</span>
  //       <br />
  //       <span style={{ fontWeight: 'bold', color: '#F37320' }}>{tCount || 0}</span>
  //     </Typography>
  //   );
  // };
  // const getSummaryActivatedSites = tCount => {
  //   return (
  //     <Typography style={{ textAlign: 'center', opacity: 1, color: '#999999' }}>
  //       <span style={{ fontSize: '12px' }}>{I18n.t('dashboard.activatedSites')}</span>
  //       <br />
  //       <span style={{ fontWeight: 'bold', color: '#F37320' }}>{tCount || 0}</span>
  //     </Typography>
  //   );
  // };

  const handleFilter = e => {
    let filterValue = filterOptions[e.target.value] || 'all';
    let searchParam = '';
    let searchParamList = [];
    if (filterValue === 'all') {
      filterValue = { name: 'all' };
      searchParam = `search_value=_ALL_SITES_`;
    } else if (get(filterValue, 'isSavedSearch', false)) {
      const filter = get(filterValue, 'filter', '') || '';
      const sort = get(filterValue, 'sort', '') || '';
      if (!isEmpty(filter)) {
        Object.keys(filter).forEach(key => key && searchParamList.push(`site[${key}][text]=${filter[key]}`));
      }
      if (!isEmpty(sort)) {
        Object.keys(sort).forEach(key => key && searchParamList.push(`site[${key}][order_by]=${sort[key]}`));
      }
      searchParam = searchParamList.join('&');
    } else {
      searchParam = `site[group_id][text]=${get(filterValue, 'id', '')}`;
    }
    const connector = searchParam ? '&' : '';
    setSelectedFilter({ ...selectedFilter, [field]: filterValue });
    setShowFilterTooltip(false);
    getFilteredList({ searchParam: `${searchParam}${connector}limit=10`, searchType: field });
  };

  const resetFilter = () => {
    setSelectedFilter({ ...selectedFilter, [field]: { name: 'all' } });
    getFilteredList({ searchParam: `search_value=_ALL_SITES_&limit=10`, searchType: field });
  };

  const getViewAllAlertURL = () => {
    if (selectedFilter['alert'].name !== 'all') {
      const isSavedSearch = get(selectedFilter, 'alert.isSavedSearch', false) || false;
      const id = get(selectedFilter, 'alert.id');
      const searchParam = isSavedSearch ? `savedSearch=${id}` : `group_id=${id}`;
      return `${settings.enlightenMenuUrl('systems')}?${searchParam}&status=any`;
    }
    return '';
  };

  const handleShowActiveLeads = () => {
    if (!currentFetchingLeads) {
      const criteria = showActiveLeads ? 'all' : 'active';
      setCurrentlyFetchingLeads(true);
      getLeads({
        companyId,
        pageNum: 0,
        recordCount: 25,
        criteria: criteria,
        successCb: () => setCurrentlyFetchingLeads(false)
      });
      setShowActiveLeads(!showActiveLeads);
    }
  };

  return (
    <Box className={classes.root} id="systemsBox">
      <PanelTemplate header={I18n.t('dashboard.systems')} boxShadow>
        <Box className={classes.tabsWrapper}>
          <AppBar position="static" className={classes.tabHeader}>
            <AntTabs value={value} onChange={handleChange} aria-label="wrapped label tabs example">
              <AntTab value={0} label={I18n.t('dashboard.all')} wrapped style={{ margin: '0px' }} id="allTab" />
              {!fromITK && (
                <AntTab
                  value={1}
                  label={`${I18n.t('dashboard.alerts')} (${alertListTotalCount})`}
                  wrapped
                  style={{ margin: '0px' }}
                  id="alertsTab"

                />
              )}
              {!fromITK && (
                <AntTab
                  value={2}
                  label={`${I18n.t('dashboard.activations')} (${activationListTotalCount})`}
                  wrapped
                  id="activationsTab"

                />
              )}
              {showAddNew ? <SystemHeaderFooter isLead={value === 3} /> : null}
              {/* <AntTab
                label={getSummaryTotal(systemList.total_count + activationList.total_count + leadList.totalLeads)}
                disabled
                wrapped={false}
                style={{ opacity: 1, margin: '0px' }}
              />
              <AntTab
                label={getSummaryLeads(leadList.totalLeads)}
                disabled
                wrapped={false}
                style={{ opacity: 1, margin: '0px' }}
              />
              <AntTab
                label={getSummaryActivation(activationList.total_count)}
                disabled
                wrapped={false}
                style={{ opacity: 1, margin: '0px' }}
              />
              <AntTab
                label={getSummaryActivatedSites(systemList.total_count)}
                disabled
                wrapped={false}
                style={{ opacity: 1, margin: '0px' }}
              /> */}
            </AntTabs>
          </AppBar>

          <Box className={classes.searchWrapper}>
            <ClickAwayListener onClickAway={() => setShowSearchResult(false)}>
              <Box className={classes.search} id="systemsSearchBox">
                <Box className={classes.searchIcon}>
                  <SearchIcon />
                </Box>
                <InputBase
                  value={searchValue}
                  onChange={e => handleSearch(e)}
                  onFocus={() => setShowSearchResult(true)}
                  className={classes.inputField}
                  placeholder={I18n.t('dashboard.search')}
                  inputProps={{ 'aria-label': 'search' }}
                  disabled={field === 'lead' || alertLoading || activationLoading || systemLoading}
                />
              </Box>
            </ClickAwayListener>
            {value === 3 && (
              <Box className={classes.switchLeadStatus}>
                <FormGroup className={classes.switchLeadFormGroup}>
                  <Box className={classes.allLeads}>All leads</Box>
                  <FormControlLabel
                    control={<Switch checked={showActiveLeads} onChange={handleShowActiveLeads} color="primary" />}
                    label="Active leads"
                    labelPlacement="end"
                  />
                </FormGroup>
              </Box>
            )}
            {showSearchResult && searchValue && !isEmpty(searchList) ? (
              <Box className={classes.searchListWrapper}>
                {searchList.result && searchList.result.length && searchList.result.length > 0 ? (
                  <Fragment>
                    {searchList.result.map((list, index) => {
                      const url = list.is_activation ? (isActivationenalbed && (accountData?.preferred_new_activation_view === null || accountData?.preferred_new_activation_view)) || enableNewActivationOnly ? `manager/dashboard/activations/${list.id}?fromEnlighten=${true}` : `activations/edit/${list.id}` : `systems/${list.id}`;
                      const label = get(list, 'id', '') ? (
                        <Link
                          target="_blank"
                          key={index}
                          href={settings.enlightenMenuUrl(url)}
                          className={classes.searchList}
                        >
                          {list.label}
                        </Link>
                      ) : (
                        <Typography className={classes.noResult}>
                          {get(list, 'label', '') || I18n.t('dashboard.noResult')}
                        </Typography>
                      );
                      return label;
                    })}
                  </Fragment>
                ) : (
                  <Typography className={classes.noResult}>{I18n.t('dashboard.noResult')}</Typography>
                )}
              </Box>
            ) : (
              <Fragment />
            )}
            {(value === 1 || value === 2) &&
              !(alertLoading || activationLoading) && (
                <LightTooltip
                  title={
                    <ClickAwayListener onClickAway={() => setShowFilterTooltip(false)}>
                      <Box>
                        <Typography className={classes.filterText}>Filter</Typography>
                        <FormControl className={classes.formControl}>
                          <InputLabel htmlFor="grouped-native-select">System Groups / Saved Search</InputLabel>
                          <Select
                            native
                            defaultValue={selectedFilter[field].name || 'all'}
                            id="grouped-native-select"
                            onChange={e => handleFilter(e)}
                          >
                            <option value="all">All</option>
                            {field === 'alert' &&
                              !isEmpty(savedSearch) && (
                                <optgroup label="Saved Searches">
                                  {savedSearch.map((search, index) => <option value={index}>{search.name}</option>)}
                                </optgroup>
                              )}
                            {field === 'alert' &&
                              !isEmpty(systemSearch) && (
                                <optgroup label="System Groups">
                                  {systemSearch.map((search, index) => (
                                    <option value={savedSearch.length + index}>{search.name}</option>
                                  ))}
                                </optgroup>
                              )}
                            {field === 'activation' &&
                              !isEmpty(activationSavedSearch) && (
                                <optgroup label="Saved Searches">
                                  {activationSavedSearch.map((search, index) => (
                                    <option value={index}>{search.name}</option>
                                  ))}
                                </optgroup>
                              )}
                          </Select>
                        </FormControl>
                      </Box>
                    </ClickAwayListener>
                  }
                  open={showFilterTooltip}
                  placement="bottom"
                  arrow
                >
                  <div className={classes.filterIconWrapper}>
                    <IconButton className={classes.filterIcon} onClick={() => setShowFilterTooltip(true)}>
                      <FilterIcon />
                    </IconButton>
                    {selectedFilter[field].name !== 'all' && (
                      <div className={classes.filterWrapper}>
                        <Typography>{selectedFilter[field].name}</Typography>
                        <HighlightOffRoundedIcon className={classes.closeIcon} onClick={resetFilter} />
                      </div>
                    )}
                  </div>
                </LightTooltip>
              )}
          </Box>
          <TabPanel value={value} index={0}>
            {dashboardLoading ? (
              <CircularProgress className={classes.loaderSystemsTable} />
            ) : (
              <SystemsTable systemDetails={dashboardList && dashboardList.result} navigationUrl="systems" />
            )}
            <SystemHeaderFooter footer />
          </TabPanel>
          <TabPanel value={value} index={1}>
            {alertLoading ? (
              <CircularProgress className={classes.loaderSystemsTable} />
            ) : (
              <SystemsTable systemDetails={alertList.result} navigationUrl="systems" />
            )}
            <SystemHeaderFooter footer viewAllUrl={getViewAllAlertURL()} />
          </TabPanel>
          <TabPanel value={value} index={2}>
            {activationLoading ? (
              <CircularProgress className={classes.loaderSystemsTable} />
            ) : (
              <SystemsTable systemDetails={activationList.result} navigationUrl="activations/edit" isActivation accountData={accountData} />
            )}
            <SystemHeaderFooter footer viewAllUrl={settings.enlightenMenuUrl('activations')} />
          </TabPanel>
          <TabPanel value={value} index={3}>
            {currentFetchingLeads ? (
              <CircularProgress className={classes.loader} color="inherit" />
            ) : (
              <Box>
                <SystemsTable
                  systemDetails={leadList.result}
                  companyId={companyId}
                  leadsLoading={leadsLoading}
                  isLead
                  openNewWindow={true}
                />
                <SystemHeaderFooter
                  footer
                  viewAllUrl={getPlatformBasedUrl('dashboard.systemsTable.viewFullList', { companyId })}
                />
              </Box>
            )}
          </TabPanel>
        </Box>
      </PanelTemplate>
    </Box>
  );
};
const mapDispatchToProps = dispatch => ({
  getAllActivationList: payload => dispatch(getAllActivationList(payload)),
  getAllAlertList: payload => dispatch(getAllAlertList(payload))
});

const mapStateToProps = state => ({
  activationList: state.dashboardReducer.activationList,
  alertList: state.dashboardReducer.alertList,
  dashboardLoading: state.dashboardReducer.dashboardLoading,
});
export default connect(mapStateToProps, mapDispatchToProps)(Systems);
